import type { FeedItem as FeedItemType } from '@whispers/sdk';
import { Link } from 'react-router-dom';

import { Button } from '../Button.js';
import { DeckCardImage } from '../DeckCardImage.js';
import { FeedItem } from './FeedItem.js';

type CardUnlockFeedItemProps = { item: Extract<FeedItemType, { type: 'card_unlock' }> };

export const CardUnlockFeedItem = ({ item }: CardUnlockFeedItemProps) => (
  <FeedItem label="Card unlocked" occurredAt={item.occurredAt}>
    <div className="flex items-center gap-5">
      <Link
        to={`/decks/${item.card.deckSlug}/cards/${item.card.slug}`}
        className="w-20 shrink-0 rounded-lg transition-transform hover:-translate-y-1 focus:outline-none focus:ring-2 focus:ring-focus-ring sm:w-24"
        aria-label={`Explore ${item.card.name}`}
      >
        <DeckCardImage
          className="w-full"
          slug={item.card.slug}
          deckSlug={item.card.deckSlug}
          name={item.card.name}
        />
      </Link>
      <div>
        <p className="text-lg font-medium text-text">{item.card.name}</p>
        <p className="mt-1 text-sm leading-6 text-text-secondary">
          {item.card.description ?? 'This card has joined your growing collection.'}
        </p>
        <p className="mt-2 text-xs text-text-secondary">Explore its story and symbolism.</p>
      </div>
    </div>
    <Button
      href={`/decks/${item.card.deckSlug}/cards/${item.card.slug}`}
      variant="secondary"
      className="mt-5 w-full"
    >
      Explore {item.card.name}
    </Button>
  </FeedItem>
);
